<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<div class="section level2" id="australia">
<h2>Australia</h2>
<p>In this ancient land,</p>
<p>Full of natural treasures,</p>
<p>Lie many ecosystems,</p>
<p>Creating varied weathers,</p><br/>
<p>The dry, dusty deserts,</p>
<p>House snakes and kangaroos,</p>
<p>And camel-walking tourists,</p>
<p>Walk through in dusty shoes.</p><br/>
<p>Many tribes and nations,</p>
<p>Live in the vast red centre,</p>
<p>They track through the landscape,</p>
<p>They know the space, landforms and weather.</p><br/>
<p>In several places, the desert meets the sea,</p>
<p>And to look out from the cliff edge,</p>
<p>Makes you feel so free.</p><br/>
<p>Forests grow along the coast,</p>
<p>Down the Eastern Sea Board,</p>
<p>Green meeting blue,</p>
<p>Along the vibrant shore.</p>
<p>All the major cities,</p>
<p>Spring up near seas or rivers,</p>
<p>The mighty running waters,</p>
<p>Really are givers.</p><br/>
<p>Mangroves and grasses,</p>
<p>Line the estuaries,</p>
<p>In these sacred spaces,</p>
<p>The tide varies.</p><br/>
<p>Sometimes up, sometimes down,</p>
<p>Sometimes king,</p>
<p>A great space to watch,</p>
<p>Many birds on the wing!</p><br/>
<p>Beaches—special places where the land meets the sea,</p>
<p>Australians love the sandy shore; the water sets us free!</p>
<p>We love playing water sports,</p>
<p>Many and varied,</p>
<p>This special meeting place is meant to be shared.</p><br/>
<p>From the tropics to the cool,</p>
<p>From the forests to the sea,</p>
<p>This celebrated land,</p>
<p>Belongs to you and me!</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?358a1bb1